import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { adminApi } from "@/lib/auth";
import { errorText } from "@/lib/errors";
import { Empty, Loading, Mail, useAdminList, when } from "./shared";

export const PrayerTab = () => {
  const { items, reload } = useAdminList("/admin/prayer-requests");
  const remove = async (p) => {
    if (!window.confirm("Delete this prayer request?")) return;
    try { await adminApi.delete(`/admin/prayer-requests/${p.id}`); toast.success("Prayer request deleted."); reload(); } catch (err) { toast.error(errorText(err)); }
  };
  if (!items) return <Loading />;
  if (!items.length) return <Empty testId="prayer-empty">No prayer requests yet.</Empty>;
  return (
    <ul className="grid gap-4" data-testid="admin-prayer-list">
      {items.map((p) => (
        <li key={p.id} className="bg-paper rounded-2xl p-6" data-testid={`admin-prayer-${p.id}`}>
          <div className="flex flex-wrap justify-between gap-2">
            <p className="font-medium">{p.name || "Anonymous"}{p.email && <span className="font-normal text-sm"> · <Mail to={p.email} /></span>}</p>
            <div className="flex items-center gap-4">
              <p className="text-sm text-moss">{when(p.created_at)}</p>
              <button type="button" onClick={() => remove(p)} aria-label="Delete prayer request" className="text-moss hover:text-red-800" data-testid={`prayer-delete-${p.id}`}><Trash2 size={14} /></button>
            </div>
          </div>
          <p className="mt-3 whitespace-pre-line">{p.request}</p>
        </li>
      ))}
    </ul>
  );
};
